var Sound = /** @class */ (function () {
    function Sound() {
        this.isEnable = true;
    }
    return Sound;
}());
export { Sound };
